/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * Rebuy Smart Cart "Subscribe & Save" uses selling plan ids from Rebuy's
   * product cache. After a Recharge plan is recreated those ids no longer
   * match Shopify, and /cart/change.js returns 422 "Cannot apply selling plan
   * to variant" — the button looks like it does nothing. Before a frequency
   * switch, copy the live plan ids from /products/{handle}.js onto the item.
   */
  (function syncRebuySellingPlans() {
    const productCache = new Map();

    const routesRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const loadProduct = (handle) => {
      if (!productCache.has(handle)) {
        productCache.set(
          handle,
          fetch(`${routesRoot()}products/${encodeURIComponent(handle)}.js`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        );
      }
      return productCache.get(handle);
    };

    const livePlansForVariant = (product, variantId) => {
      if (!product) return [];
      const variant = (product.variants || []).find((entry) => entry.id === variantId);
      if (!variant) return [];

      const plans = [];
      (product.selling_plan_groups || []).forEach((group) => {
        (group.selling_plans || []).forEach((plan) => {
          const allocated = (variant.selling_plan_allocations || []).some(
            (allocation) => allocation.selling_plan_id === plan.id
          );
          if (allocated) plans.push(plan);
        });
      });
      return plans;
    };

    const matchLivePlan = (rebuyPlan, livePlans, index) => {
      const values = new Set((rebuyPlan.options || []).map((option) => String(option.value)));
      const byOption = livePlans.find((plan) =>
        (plan.options || []).some((option) => values.has(String(option.value)))
      );
      if (byOption) return byOption;

      const byName = livePlans.find((plan) => plan.name && plan.name === rebuyPlan.name);
      if (byName) return byName;
      if (livePlans.length === 1) return livePlans[0];
      return livePlans[index] || null;
    };

    const applyLivePlans = (item, livePlans) => {
      const product = item.product;
      const variant = product && product.selected_variant;
      if (!variant || !livePlans.length) return;

      const idToLiveId = new Map();
      const retarget = (plan, index) => {
        if (!plan) return;
        const previousId = plan.id;
        const live = matchLivePlan(plan, livePlans, index);
        if (!live) return;
        idToLiveId.set(String(previousId), live.id);
        plan.id = live.id;
      };

      (variant.selling_plans || []).forEach(retarget);
      (product.selling_plan_groups || []).forEach((group) => {
        (group.selling_plans || []).forEach(retarget);
      });
      (variant.selling_plan_allocations || []).forEach((allocation, index) => {
        const liveId = idToLiveId.get(String(allocation.selling_plan_id));
        const fallback = livePlans.length === 1 ? livePlans[0].id : livePlans[index] && livePlans[index].id;
        if (liveId || fallback) allocation.selling_plan_id = liveId || fallback;
      });
    };

    const syncItem = (item) => {
      const handle = item && (item.handle || (item.product && item.product.handle));
      const variantId = item && (item.variant_id || item.id);
      if (!handle || !variantId || !item.product) return Promise.resolve();

      return loadProduct(handle).then((product) => {
        applyLivePlans(item, livePlansForVariant(product, variantId));
      });
    };

    const install = () => {
      const cart = window.Rebuy && window.Rebuy.Cart;
      if (!cart || typeof cart.switchItemToFrequency !== 'function') return;
      if (cart.switchItemToFrequency.__sellingPlanSync) return;

      const original = cart.switchItemToFrequency.bind(cart);
      const wrapped = function (item, frequency, success, error) {
        syncItem(item).finally(() => original(item, frequency, success, error));
      };
      wrapped.__sellingPlanSync = true;
      cart.switchItemToFrequency = wrapped;
    };

    const prefetch = () => {
      install();
      const items = window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.items && window.Rebuy.Cart.items();
      (items || []).forEach(syncItem);
    };

    ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:smartcart.ready'].forEach((name) => {
      document.addEventListener(name, prefetch);
    });

    const timer = setInterval(install, 500);
    setTimeout(() => clearInterval(timer), 15000);
    install();
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
